import { IHttpApi } from '@cian/http-api';
import {
  IGetConstructionProgressRequest,
  TGetConstructionProgressResponse,
  fetchGetConstructionProgress,
} from '../../repositories/construction-progress/v1/get-construction-progress';
import { IGetConstructionProgressResponse } from '../../../shared/types/constructionProgress';
import { transformConstructionProgressResponse } from '../../mappers/transformConstructionProgressResponse';
import { ResponseError } from '../../utils/errors';

export async function getConstructionProgress(
  httpApi: IHttpApi,
  parameters: IGetConstructionProgressRequest,
): Promise<IGetConstructionProgressResponse> {
  const response: TGetConstructionProgressResponse = await fetchGetConstructionProgress({ httpApi, parameters });

  if (response.statusCode !== 200) {
    const { errors, message } = response.response;

    throw new ResponseError({
      domain: 'shared/services/getConstructionProgress',
      message: 'Failed get construction progress',
      details: { errors: JSON.stringify(errors), message },
    });
  }

  return transformConstructionProgressResponse(response.response);
}
